import { NumberQuizState } from "@shared/types/NumberQuizState";
import { PlayerService } from "./PlayerService";

/**
 * Making a request to the API to get the current state of the number quiz
 * @returns The current state of the number quiz
 */
export class NumberQuizService {
    private readonly _playerService: PlayerService = new PlayerService();

    public async getQuestion(): Promise<NumberQuizState> {
        const question: NumberQuizState = await fetch(`${VITE_API_URL}numQuiz/check-quiz/question`, {
            headers: {
                "x-playersessionid": this._playerService.getPlayerSessionId(),
            },
        }).then(res => res.json() as Promise<NumberQuizState>);
        return question;
    }

    /**
     * Making a request to the API to post the answer to the number quiz
     * @returns The current state of the number quiz
     */
    public async checkAnswer(answer: number): Promise<NumberQuizState> {
        return await fetch(`${VITE_API_URL}numQuiz/check-quiz/answer`, {
            method: "POST",
            headers: {
                "x-playersessionid": this._playerService.getPlayerSessionId(),
                "content-type": "application/json",
            },
            body: JSON.stringify({
                answer: answer,
            }),
        }).then(res => res.json() as Promise<NumberQuizState>);
    }
}
